/**
 * transform: skew(*); を適用した要素にできる三角形の隙間を
 * 三角関数を使用してサイズ求める
 * @param {*} skewElement
 * @param {*} deg
 */
export default function(skewElement, deg) {
  const rad = deg * Math.PI / 180;
  const tan = Math.tan(rad)
  const height = skewElement.clientHeight;

  return Math.round(height / tan * 1000) / 1000;
}